import { render, staticRenderFns } from "./Plants.vue?vue&type=template&id=75c366e0&scoped=true&"
import script from "./Plants.vue?vue&type=script&lang=js&"
export * from "./Plants.vue?vue&type=script&lang=js&"
import style0 from "./Plants.vue?vue&type=style&index=0&id=75c366e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c366e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VProgressCircular,VRow})
